export enum EUserAccountStatus {
  INACTIVE = 'INACTIVE',
  INVITED = 'INVITED',
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
}
